import React, { useContext } from 'react';

import AppContext from '@zimpel/AppContext';
import * as images from './images';

type Props = { alt: string }

export const HeaderLogo: React.FC<Props> = ({ alt }) => {
  const { theme } = useContext(AppContext);
  return (
    <img alt={alt} src={images[`${theme}Logo`]} />
  );
};

export const FooterLogo: React.FC<Props> = ({ alt }) => (
  <img alt={alt} src={images.naLogoFooter} />
);
